

















































import {Component, Vue, Inject, Emit} from "vue-property-decorator";
import Antd from "ant-design-vue";
import AbpBase from "@/lib/abpbase";
import _ from "lodash";
import {API_CheckCode, API_GetRegisterCaptcha, API_GetSmsCaptcha, API_Register} from "@/api/login";

const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
};

@Component({
    components: {}
})
export default class registerForm extends AbpBase {
    form: any;
    formItemLayout = formItemLayout;
    isLoginError = false

    state = {
        time: 60,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: '#FF0000'
    }

    beforeCreate(){
        this.form = this.$form.createForm(this);
    }

    handleSubmit(e) {
        var self = this;
        e.preventDefault();
        self.form.validateFields(async (err, values) => {
            if (err) {
                return;
            }

            //检查验证码
            API_CheckCode(values).then((res)=>{
                let {data,errno,message} = res.data;
                if(errno!=0){
                    this.$message.info(message);
                    return;
                }

                let uuid = data.uuid;
                this.fillUserInfo({uuid:uuid,mobile:values.mobile});
            })

        });
    }


    getCaptcha(e){
        e.preventDefault()
        const { form: { validateFields }, state } = this
        validateFields(['mobile'], { force: true }, (err, values) => {
            if (!err) {
                state.smsSendBtn = true

                const interval = window.setInterval(() => {
                    if (state.time-- <= 0) {
                        state.time = 60
                        state.smsSendBtn = false
                        window.clearInterval(interval)
                    }
                }, 1000)


                API_GetRegisterCaptcha({ mobile: values.mobile }).then(res => {
                    let {data,errno,message} = res.data;
                    if(errno!=0){
                        this.$notification['info']({
                            message: '提示',
                            description: message,
                            duration: 8
                        })
                        return;
                    }
                    const hide:any = this.$message.loading('验证码发送中,请查看手机短信', 0)
                    setTimeout(hide, 2500)
                }).catch(err => {
                    // setTimeout(hide, 1)
                    clearInterval(interval)
                    state.time = 60
                    state.smsSendBtn = false
                    this.requestFailed(err)
                })
            }
        })
    }
    requestFailed (err) {
        this.isLoginError = true
        this.$notification['error']({
            message: '错误',
            description: ((err.response || {}).data || {}).message || '请求出现错误，请稍后再试',
            duration: 4
        })
    }

    @Emit("fill")
    fillUserInfo(data){
        return data;
    }

}
